import React, { useState, useEffect } from 'react';
import {
  faPen,
  faTrash,
  faEye
} from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ActionConfirmForm from '../common/ActionConfirmForm';
import './SubscriptionItem.scss';

const ReactSwal = withReactContent(Swal);

const SubscriptionItem = props => {

   const onDeleteSubscriptionItem = () => {
    ReactSwal.fire({
      allowOutsideClick: true,
      allowEscapeKey: true,
      allowEnterKey: false,
      showCancelButton: false,
      showConfirmButton: false,
      html: (
        <ActionConfirmForm
          onConfirm={ReactSwal.clickConfirm}
          onClose={ReactSwal.clickCancel}
          title="Delete Subscription"
          question={`Are you sure you want to delete this subscription?`}
        />
      )
    })
    .then(async result => {
      if (result.value) {
        props.onDelete();
       }
    });
  };
  
  

 
  

  return (
    <div className={`  subscription-container`}  >


     <div className='subscription-info'>

      <span className="subscription-name">{props.data.name}</span>
      <span className="subscription-name">{props.data.deliveryUrl}</span>

     
        </div>
      
        <div className="actions">
          <FontAwesomeIcon onClick={props.onPreview} icon={faEye} />
          <FontAwesomeIcon onClick={props.onEdit} icon={faPen} />
          <FontAwesomeIcon onClick={onDeleteSubscriptionItem} icon={faTrash} />
        </div>
     </div>
  )
}

export default SubscriptionItem;